import _ from 'lodash';
import moment from 'moment';

/**
 * Service to allow searching for videos
 */
export default class FineTuneVideosService {
	/**
	 * @param Api
	 */
	constructor(Api) {
		'ngInject';
		/**
		 * The Api service instance
		 */
		this.Api = Api;
	}

	/**
	 * Fetch posts matching the given search parameters
	 * @param {Object} search
	 * @property {Number[]} ids  Specific IDs to use
	 * @property {Number[]} not_ids  Specific IDs to exclude
	 * @property {String} term  The search term
	 * @property {String} dateStart  The minimum and maximum date values
	 * @property {String} datert  The minimum and maximum date values
	 * @property {String} datePreset  The name of a date preset to use
	 * @param {Object} options
	 * @returns {Promise}
	 */
	fetch(search, options = {}) {
		let params = {};
		if (search.ids && search.ids.length) {
			params.ids = search.ids.join(',');
		} else {
			params.term = search.term || undefined;
			params.not_ids = search.not_ids ? search.not_ids.join(',') : undefined;
			if (search.datePreset == 'custom') {
				if (this.hasValidDates(search)) {
					params.date = this.getDateRange(search).join(',');
				}
			} else if (search.datePreset != 'all') {
				params.date_preset = search.datePreset;
			}
		}
		return this.Api.get('/videos/search', params, this._getHeaders(options));
	}

	/**
	 * Check if the search parameters have a valid dateStart and dateEnd
	 * @param {Object} search
	 * @returns {Boolean}
	 */
	hasValidDates(search) {
		return moment(search.dateStart).isValid() && moment(search.dateEnd).isValid();
	}

	/**
	 * Get an array of formatted start/end dates based ont eh search parameters
	 * @param {Object} search
	 * @returns {String[]}
	 */
	getDateRange(search) {
		return [
			moment(search.dateStart).format('YYYY-MM-DD') + ' 00:00:00',
			moment(search.dateEnd).format('YYYY-MM-DD') + ' 23:59:59',
		];
	}

	/**
	 * Get the headers to use for the API request; currently just Hubs
	 * @param {Object} options
	 * @returns {Object}
	 * @private
	 */
	_getHeaders(options) {
		let headers = {};
		if (options.hubs && options.hubs.length > 0) {
			headers.Hubs = _.isArray(options.hubs) ? options.hubs.join(',') : options.hubs;
		}
		return headers;
	}
}
